import { render, staticRenderFns } from "./PrivateCellRenderer.vue?vue&type=template&id=20f52331&scoped=true&lang=pug&"
import script from "./PrivateCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./PrivateCellRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateCellRenderer.vue?vue&type=style&index=0&id=20f52331&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f52331",
  null
  
)

export default component.exports